import { getGridDateOperators as getGridDateOperatorsDefault } from "@mui/x-data-grid-pro";

import { CustomGridFilterInputDateTime } from "./components/CustomGridFilterInputDateTime";

const UNWANTED_DATE_OPERATORS = ["isAnyOf", "isEmpty", "isNotEmpty", "is", "not"];

export const getGridDateOperators = () =>
  getGridDateOperatorsDefault(true)
    .filter((operator) => !UNWANTED_DATE_OPERATORS.includes(operator.value))
    .map((operator) => ({
      ...operator,
      InputComponent: CustomGridFilterInputDateTime
    }));
